import React, { ReactNode } from "react";

export default function HeaderItemWrapper({
	children,
}: {
	children: ReactNode;
}) {
	return <>{children}</>;
}
